import { render } from "./SoldVehicles.vue?vue&type=template&id=b44d0d50"
import script from "./SoldVehicles.vue?vue&type=script&lang=js"
export * from "./SoldVehicles.vue?vue&type=script&lang=js"

import "./SoldVehicles.vue?vue&type=style&index=0&id=b44d0d50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__